import { TertiaryTableColumn } from "@hatch-digital-nl/abs-storybook/legacy";

export const getEstablishmentCertificateColumns = (): TertiaryTableColumn[] => {
    return [
        {
            value: "Datum behaald",
        },
        {
            value: "Vervalt op",
        },
        {
            value: "Certificaat",
        },
    ];
};
